import { MobXProviderContext, observer } from 'mobx-react';
import { ContactModelV2 } from 'Models/ContactModelV2';
import React, { useCallback, useContext } from 'react';
import { RootStoreProps } from 'Stores/RootStore.types';
import { Button } from '~/lib/ui/button';
import {
  SidebarGroup,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuItem,
} from '~/lib/ui/sidebar';
import { GroupMemberCard } from './GroupMemberCard';
import { useGroupMemberContacts } from './hooks/useGroupMemberContacts';
import { GroupDetailsMembersProps } from './index.types';

export const GroupDetailsMembers = observer(
  ({ conversation, openContactDetails }: GroupDetailsMembersProps) => {
    const {
      conversation: { setChannelInfoDetails },
      ui: { setGroupModal, setMoreActionOptions, setOpeningGroupModalFrom },
    } = useContext<RootStoreProps>(MobXProviderContext);

    const { members, loadingContacts } = useGroupMemberContacts(
      conversation.id
    );

    const isChannel = conversation.grouping === 'Channel';

    const handleAddMember = useCallback(() => {
      setGroupModal(true);
      setChannelInfoDetails(conversation.id, 'edit');
      setMoreActionOptions({ show: false, conversationId: '' });
      setOpeningGroupModalFrom('edit');
    }, [
      conversation.id,
      setChannelInfoDetails,
      setGroupModal,
      setMoreActionOptions,
      setOpeningGroupModalFrom,
    ]);

    if (loadingContacts) {
      return null;
    }

    return (
      <SidebarGroup className="px-[7px]">
        <SidebarGroupLabel className="flex justify-between">
          Members (
          {
            members.filter(
              (member) =>
                !(
                  member.contact instanceof ContactModelV2 &&
                  member.contact.deleted
                )
            ).length
          }
          )
          {isChannel && (
            <Button
              onClick={handleAddMember}
              variant="link"
              size="sm"
              className="p-0 h-auto hover:no-underline"
            >
              Add
            </Button>
          )}
        </SidebarGroupLabel>
        <SidebarMenu className="px-0">
          <SidebarMenuItem className="flex flex-col gap-2 px-0">
            {members.map((member) => (
              <GroupMemberCard
                key={member.contact.id}
                contact={member.contact}
                openContactDetails={openContactDetails}
                phoneNumber={member.phoneNumber}
              />
            ))}
          </SidebarMenuItem>
        </SidebarMenu>
      </SidebarGroup>
    );
  }
);
